// extracted by mini-css-extract-plugin
export default {"wrapper":"Create_wrapper__F7k5r","col":"Create_col__vEzJs"};